import { combineEpics, ofType } from "redux-observable";
import { catchError, EMPTY, from, map, mergeMap, of, switchMap, withLatestFrom } from "rxjs";
import { RootState } from "../../../store/ConfigureStore";
import { getArea, getNozzleThroatList } from "../../../services/jetlift/jetlift-input/jetPump.service";
import { setDarcey, setNozzleAreaSize, setNozzleDiameterSize, setNozzleList, setNozzleValue, setTangent, setThroatAreaSize, setThroatDiameterSize, setThroatList, setThroatValue } from "../../../store/jetlift/jetlift-input/JetPumpSlice";

const getNozzleThroatListEpic = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "jetlift/jetPump/setManufacturerId",
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.jetlift?.jetPump?.jetPump)),
        ),
        switchMap(([actionData, jetPumpInput]) => {
            return from(getNozzleThroatList(jetPumpInput?.manufacturerId)).pipe(
                mergeMap((data) => {
                    return [
                        setNozzleList(data?.nozzles || []),
                        setNozzleValue(""),
                        setNozzleDiameterSize(""),
                        setThroatList(data?.throats || []),
                        setThroatValue(""),
                        setThroatDiameterSize(""),
                    ]
                }),
                catchError((error) => {
                    console.error(error);
                    return of({ type: 'jetlift/jetPump/setError', payload: error?.message, error: true });
                })
            );
        })
    );
};

const getNozzleAreaEpic = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "jetlift/jetPump/getNozzleArea",
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.jetlift?.jetPump?.jetPump)),
        ),
        switchMap(([actionData, jetPumpInput]) => {
            if (+jetPumpInput?.nozzleDiameterSize > 0) {
                return from(getArea(+jetPumpInput?.nozzleDiameterSize)).pipe(
                    mergeMap((data) => {
                        return [
                            setNozzleAreaSize(data?.area?.toString() || ""),
                            setNozzleDiameterSize(data?.diameter?.toString() || ""),
                        ];
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of({ type: 'jetlift/jetPump/setError', payload: error?.message, error: true });
                    })
                );
            }
            return EMPTY;
        })
    );
};

const getThroatAreaEpic = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "jetlift/jetPump/getThroatArea",
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.jetlift?.jetPump?.jetPump)),
        ),
        switchMap(([actionData, jetPumpInput]) => {
            if (+jetPumpInput?.throatDiameterSize > 0) {
                return from(getArea(+jetPumpInput?.throatDiameterSize)).pipe(
                    mergeMap((data) => {
                        return [
                            setThroatAreaSize(data?.area?.toString() || ""),
                            setThroatDiameterSize(data?.diameter?.toString() || ""),
                        ];
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of({ type: 'jetlift/jetPump/setError', payload: error?.message, error: true });
                    })
                );
            }
            return EMPTY;
        })
    );
};

const getTangentEpic = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("jetlift/jetPump/setTangent",),
        withLatestFrom(state$.pipe(map((state: RootState) => state?.jetlift?.jetPump?.jetPump)),),
        switchMap(([actionData, jetPumpInput]) => {
            const tangentValue = "";
            return of(setTangent(tangentValue.toString()));
        })
    );
};

const getDarceyEpic = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("jetlift/jetPump/setDarcey",),
        withLatestFrom(state$.pipe(map((state: RootState) => state?.jetlift?.jetPump?.jetPump)),),
        switchMap(([actionData, jetPumpInput]) => {
            const darceyValue = "";
            return of(setDarcey(darceyValue.toString()));
        })
    );
};

export const jetliftJetPumpEpic = combineEpics(
    getNozzleThroatListEpic,
    getNozzleAreaEpic,
    getThroatAreaEpic,
);